<script>
import { mapGetters } from 'vuex'

import PageSubmenu from '@/components/PageSubmenu.vue'
import { http } from '@/services/api.service'

export default {
  components: { PageSubmenu },
  data () {
    return {
      hasInactiveSurveys: false
    }
  },
  computed: {
    ...mapGetters(['domain', 'application']),
    links () {
      const links = [
        // {
        //   label: 'Sondages simple',
        //   path: '/app/surveys',
        //   roles: ['admin', 'director', 'community-manager', 'operator']
        // },
        {
          label: 'Actif',
          path: '/app/multisurveys',
          query: { status: 'active' },
          roles: ['admin', 'director', 'community-manager', 'operator']
        }
      ]

      if (this.hasInactiveSurveys) {
        links.push({
          label: 'Inactif',
          path: '/app/multisurveys',
          query: { status: 'inactive' },
          roles: ['admin', 'director', 'community-manager', 'operator']
        })
      }

      if (this.domain?.slug !== '0-media-interne') {
        links.push({
          label: `Sondages ${this.application.app.label}`,
          path: '/app/surveys/media-mvp',
          roles: ['admin', 'director', 'community-manager', 'operator']
        })
      }

      const filteredLinks = links.filter(Boolean)
      return filteredLinks
    }
  },
  watch: {
    '$route.query.status': {
      handler () {
        this.checkInactiveSurveys()
      }
    },
    '$route.path': {
      handler () {
        this.checkInactiveSurveys()
      }
    }
  },
  created () {
    this.checkInactiveSurveys()
  },
  mounted () {
    this.$nextTick(() => {
      this.checkInactiveSurveys()
    })
  },
  methods: {
    checkInactiveSurveys () {
      http.get('/domain/surveys', {
        params: {
          past: true,
          multiple: true
        }
      })
        .then(res => {
          const inactiveSurveys = res.data ? res.data.filter(group => !group.is_enabled) : []
          this.hasInactiveSurveys = inactiveSurveys.length > 0
        })
        .catch(() => {
          this.hasInactiveSurveys = false
        })
    }
  }
}
</script>

<template>
  <div>
    <PageSubmenu :links="links" />
  </div>
</template>
